import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../../redux/useAppDispatch";
import { RootState } from "../../../../redux/store";
import { switchCC, switchW } from "../../../../redux/JobModule/QCDetailPage/QCDetailPageAction";

const SelectAfter = () => {
  const dispatch = useAppDispatch();
  const isCCActive = useSelector((state: RootState) => state.qCDetailPageState.isCCActive);
  const isFullWordActive = useSelector((state: RootState) => state.qCDetailPageState.isFullWordActive);

  return (
    <div className="after-action d-flex gap-2">
      <div
        onClick={() => dispatch(switchCC())}
        className={`link-action ${isCCActive ? "active" : ""}`}>
        Cc
      </div>
      <div
        onClick={() => dispatch(switchW())}
        className={`link-action ${isFullWordActive ? "active" : ""}`}>
        W
      </div>
    </div>
  );
};

export default SelectAfter;
